import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import Barcode from 'react-barcode';
import axios from 'axios';
import '../css/seat_barcode.css';

const SeatReserveBarcode = (props) => {
  const { match } = props;
  const [barcode, setBarcode] = useState('');
  const param = match.params.p;
  const ticketCode = 27;

  const _getData = async () => {
    const result = await axios.post(
      'https://api.aniplustv.com:3100/seatReserveGetBarcode',
      {
        ticketCode,
        param,
      }
    );
    // console.log(result);
    const intReturn = result.data[0].intReturn;
    const listData = result.data[0].listData;
    if (intReturn === 0) {
      setBarcode(listData[0].barcode);
    }
  };

  useEffect(() => {
    _getData();
  }, [param]);

  return (
    <div className="code_container">
      <div className="code_header">
        <img src="/img/seat/barcode/top_img.png" />
      </div>
      <div className="code_content">
        <div className="code_area">
          <QRCode
            style={{ width: '80%' }}
            value={
              barcode
                ? `https://www.aniplustv.com/qrcode/qrcode_lv.asp?uid=${param}`
                : ''
            }
          />
        </div>

        <div className="code_text_contain">
          <div>
            <hr />
            <Barcode
              value={barcode ? barcode : ''}
              displayValue={false}
              height={70}
              format="CODE128"
              fontSize={9}
              margin={2}
              textMargin={1}
              width={2}
            />
          </div>
          <div className="code_text">
            <span>본인 확인용 QR코드로 아이디별 하나만 제공됩니다.</span>
          </div>
        </div>
      </div>

      <div className="code_footer">
        <img src="/img/seat/barcode/logo.png" />
      </div>
    </div>
  );
};
export default SeatReserveBarcode;
